import React, {ReactNode} from 'react';
import './index.css';

interface P {
    error: ReactNode | string
}

export default ({error}: P) => (
    <div className={`generic-err-holder`}>
        <div className={`generic-err-indicator`}>{`!`}</div>
        <div className={`generic-err-msg`}>
            {error}
        </div>
    </div>
)